export interface CurrencyPricing {
  USD: number;
  AUD: number;
  CAD: number;
  GBP: number;
}

export interface PlanData {
  name: string;
  pricing: CurrencyPricing;
  description: string;
}

export interface AppointmentPackageData {
  name: string;
  pricing: CurrencyPricing;
  description: string;
}

// Membership Plans Display Mapping with Currency-Aware Pricing
export const planDisplayMapping: Record<string, PlanData> = {
  Unlimited: {
    name: "Unlimited Monthly",
    pricing: {
      USD: 120,
      AUD: 179,
      CAD: 162,
      GBP: 96,
    },
    description: "Unlimited sessions",
  },
  "10 Class Pack": {
    name: "10 Class Pack",
    pricing: {
      USD: 150,
      AUD: 224,
      CAD: 203,
      GBP: 120,
    },
    description: "10 sessions",
  },
  "Drop-in Classes": {
    name: "Drop In Class",
    pricing: {
      USD: 25,
      AUD: 37,
      CAD: 34,
      GBP: 20,
    },
    description: "1 session",
  },
  "Monthly Membership": {
    name: "Monthly Membership",
    pricing: {
      USD: 99,
      AUD: 148,
      CAD: 134,
      GBP: 79,
    },
    description: "Monthly access",
  },
  "Annual Membership": {
    name: "Annual Membership",
    pricing: {
      USD: 999,
      AUD: 1498,
      CAD: 1349,
      GBP: 799,
    },
    description: "Annual access",
  },
  "Student Discount": {
    name: "Student Membership",
    pricing: {
      USD: 79,
      AUD: 118,
      CAD: 107,
      GBP: 63,
    },
    description: "Monthly with student ID",
  },
  "Military/First Responder Discount": {
    name: "Military/First Responder",
    pricing: {
      USD: 89,
      AUD: 133,
      CAD: 120,
      GBP: 71,
    },
    description: "Monthly with ID",
  },
  "Family Plan": {
    name: "Family Plan",
    pricing: {
      USD: 199,
      AUD: 298,
      CAD: 269,
      GBP: 159,
    },
    description: "Up to 4 members",
  },
  "Personal Training": {
    name: "Personal Training",
    pricing: {
      USD: 80,
      AUD: 120,
      CAD: 108,
      GBP: 64,
    },
    description: "1 session",
  },
};

// Appointment Packages Display Mapping with Currency-Aware Pricing
export const appointmentPackageDisplayMapping: Record<string, AppointmentPackageData> = {
  "Single Session": {
    name: "Single Session",
    pricing: {
      USD: 75,
      AUD: 112,
      CAD: 101,
      GBP: 60,
    },
    description: "1 appointment",
  },
  "5-Session Package": {
    name: "5-Session Package",
    pricing: {
      USD: 350,
      AUD: 525,
      CAD: 473,
      GBP: 280,
    },
    description: "5 appointments",
  },
  "10-Session Package": {
    name: "10-Session Package",
    pricing: {
      USD: 650,
      AUD: 975,
      CAD: 878,
      GBP: 520,
    },
    description: "10 appointments",
  },
  "Personal Training Packages": {
    name: "Personal Training Package",
    pricing: {
      USD: 400,
      AUD: 600,
      CAD: 540,
      GBP: 320,
    },
    description: "4 PT sessions",
  },
  "Consultation Only": {
    name: "Consultation",
    pricing: {
      USD: 50,
      AUD: 75,
      CAD: 68,
      GBP: 40,
    },
    description: "Initial consultation",
  },
  "Assessment + Follow-up": {
    name: "Assessment + Follow-up",
    pricing: {
      USD: 125,
      AUD: 187,
      CAD: 169,
      GBP: 100,
    },
    description: "Assessment & 1 follow-up",
  },
  "Intro Package": {
    name: "Intro Package",
    pricing: {
      USD: 99,
      AUD: 148,
      CAD: 134,
      GBP: 79,
    },
    description: "3 intro sessions",
  },
  "Specialty Sessions": {
    name: "Specialty Session",
    pricing: {
      USD: 100,
      AUD: 150,
      CAD: 135,
      GBP: 80,
    },
    description: "Specialized training",
  },
  "Group Training Packages": {
    name: "Group Training Package",
    pricing: {
      USD: 250,
      AUD: 375,
      CAD: 338,
      GBP: 200,
    },
    description: "4 group sessions",
  },
  "Semi-Private Sessions": {
    name: "Semi-Private Package",
    pricing: {
      USD: 300,
      AUD: 450,
      CAD: 405,
      GBP: 240,
    },
    description: "4 semi-private sessions",
  },
  "Drop-in Sessions": {
    name: "Drop-in Session",
    pricing: {
      USD: 85,
      AUD: 127,
      CAD: 115,
      GBP: 68,
    },
    description: "Single drop-in",
  },
  "Package + Nutrition": {
    name: "Training + Nutrition",
    pricing: {
      USD: 500,
      AUD: 750,
      CAD: 675,
      GBP: 400,
    },
    description: "4 sessions + nutrition",
  },
  "Rehabilitation Packages": {
    name: "Rehabilitation Package",
    pricing: {
      USD: 450,
      AUD: 675,
      CAD: 608,
      GBP: 360,
    },
    description: "6 rehab sessions",
  },
  "Performance Packages": {
    name: "Performance Package",
    pricing: {
      USD: 600,
      AUD: 900,
      CAD: 810,
      GBP: 480,
    },
    description: "8 performance sessions",
  },
  "Maintenance Sessions": {
    name: "Maintenance Package",
    pricing: {
      USD: 300,
      AUD: 450,
      CAD: 405,
      GBP: 240,
    },
    description: "Monthly maintenance",
  },
};
